module.exports = JBrowseExports["@mui/material"];